import React from 'react';
import {css} from 'emotion';
import IconEasyHome from '../../../common/material-easy-ui/icon/IconEasyHome';
import IconEasyProfile from '../../../common/material-easy-ui/icon/IconEasyProfile';
import IconEasySurvey from '../../../common/material-easy-ui/icon/IconEasySurvey';
import IconEasyNews from '../../../common/material-easy-ui/icon/IconEasyNews';
import ItemMenu from './components/ItemMenu';
const Menu = (props) =>{
  return(
    <div className={css`width:60px;background-color:white;position:fixed;top:60px;left:0px;height:calc(100% - 60px);display:flex;flex-direction:column`}>
      <ItemMenu location={props.location} pathname={['/']} size={30} text={'Accueil'}>
        <IconEasyHome color={'#0085C6'} size={30}/>
        </ItemMenu>
        <ItemMenu location={props.location} pathname={['/profil']}  size={30} text={'Profil'}>
          <IconEasyProfile color={'#0085C6'} size={30}/>
        </ItemMenu>
          <ItemMenu location={props.location} pathname={['/liste-formulaire','/navire-formulaire']}  size={30} text={'Formulaires'}>
            <IconEasySurvey color={'#0085C6'} size={30}/>
        </ItemMenu>
        <ItemMenu location={props.location} pathname={['/vos-déclarations']}  size={30} text={'Déclarations'}>
            <IconEasyNews color={'#0085C6'} size={30}/>
        </ItemMenu>

    </div>
  )
}

export default Menu;
